module.exports = {
  title: "Expalerts",
  vendor: "expalerts",
  defaultLocale: "en",
  supportedLocales: ["en"],
  disclaimer: "https://app.expalerts.com/static/invauth/disclaimer.pdf",
  termsAndConditionsUrl:
    "https://s3.eu-central-1.amazonaws.com/panel.expasset.com/1553525484_ddaa5f685f03_ExpRegisterTermsandConditions.pdf",
  privacyPolicyUrl:
    "https://s3.eu-central-1.amazonaws.com/panel.expasset.com/1553525484_ddaa5f685f03_ExpRegisterTermsandConditions.pdf",
  gdprInfoUrl: "https://l.squaber.com/rozszerzona-klauzula-informacyjna/",
  defaultPremiumOfferUrl: "https://squaber.com/pl/plans",
  chartImageApiUrl: "https://app.expalerts.com/:locale/api/",
  prodBaseUrl: "https://expalerts.com/",
  cookieDomain: ".expalerts.com",
  authTokenCookieName: "expalerts_auth_token",
  registerUrl: "https://testing.expregister.com/register",
  alertCategories: [
    { name: "Interesting Situation", key: "interesting_situation" },
    { name: "Price Alerts", key: "price_alerts" },
    {
      name: "Demand Zones Strategy Alerts",
      key: "demand_zone"
    },
    {
      name: "Demand Zones Strategy Signals",
      key: "transaction_strategy_supply_demand"
    },
    {
      name: "Donchian Channel Strategy (period H1)",
      key: "donchain_h1"
    },
    {
      name: "Ichimoku Kinko Hyo Strategy (period H1)",
      key: "ichimoku_h1"
    },
    {
      name: "Ichimoku Kinko Hyo Strategy (period H4)",
      key: "ichimoku_h4"
    }
  ]
};
